module.exports = __webpack_public_path__ + "static/img/Charlie-Nicholls.de2f5bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Charlie-Nicholls.jpg
// module id = T4Uw
// module chunks = 0